import { StyleSheet, View } from 'react-native';
import { SplashArtwork } from '../components/SplashArtwork';

export function SplashScreen() {
  return (
    <View style={styles.root} accessibilityLabel="Clubhouse">
      <SplashArtwork />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: '#18181B',
  },
});
